export enum TransportState {
  Disconnected = 'Disconnected',
  Connecting = 'Connecting',
  Joined = 'Joined',
  Preview = 'Preview',
  Failed = 'Failed',
  Reconnecting = 'Reconnecting',
  Leaving = 'Leaving',
}
